import React from "react";

type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  invalid?: boolean;
};

/**
 * Styled native `<select>`. Same chrome as <Input> with a chevron rendered as a
 * background SVG (so we don't break native dropdown behavior). Consumers pass
 * `<option>` children directly — this primitive doesn't introduce a custom
 * value list.
 */
export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  function Select({ className, invalid, children, ...rest }, ref) {
    const cls = ["tb-select", invalid ? "tb-input-invalid" : "", className]
      .filter(Boolean)
      .join(" ");
    return (
      <select ref={ref} className={cls} {...rest}>
        {children}
      </select>
    );
  },
);
